import { useHistory } from "react-router";

import { Button } from "~/components/ui/Button/Button";

export const NotFound = () => {
  const history = useHistory();
  return (
    <div className="flex min-h-[50%] flex-col items-center justify-center">
      <p className="text-3xl font-bold">Page non trouvée</p>
      <p className="mt-4 text-center text-sm text-grey-600">
        La page que vous cherchez n&apos;existe pas, veuillez vérifier l&apos;URL.
        <br />
        Vous pouvez revenir à la page précédente ou retourner à l&apos;accueil.
      </p>
      <div className="mt-6 flex gap-4">
        <Button onClick={() => history.goBack()}>Page précédente</Button>
        <Button href="/">Retour à l&apos;accueil</Button>
      </div>
    </div>
  );
};
